// extracted by mini-css-extract-plugin
module.exports = {"widget":"styles_widget__NyE8j","widget__form":"styles_widget__form__R5AG4","widget__links":"styles_widget__links__EejdQ","pulse":"styles_pulse__2Sk1t","jump":"styles_jump__R5IHM"};